/** 教务中心 - 师资管理路由 **/

// 师资管理 教师-列表
const TeachersIndex = () => import('@pv/eduCenter/teachers/Index')
// 师资管理 教师-详情
const TeachersDetails = () => import('@pv/eduCenter/teachers/Details')
// 师资管理 教师-修改
const TeachersEdit = () => import('@pv/eduCenter/teachers/Edit')

export default [
  // 轮播图管理
  {
    path: '/eduCenter/teachers/index',
    name: 'eduCenter_teachers_index',
    meta: {
      title: '教师师资库',
      activePath: '/eduCenter/teachers/index',
      breadcrumb: '教务中心-师资管理-教师师资库'
    },
    component: TeachersIndex
  },
  {
    path: '/eduCenter/teachers/index/details',
    name: 'eduCenter_teachers_details',
    meta: {
      title: '教师详情',
      activePath: '/eduCenter/teachers/index',
      breadcrumb: '教务中心-师资管理-教师师资库-教师详情'
    },
    component: TeachersDetails
  },
  {
    path: '/eduCenter/teachers/index/edit',
    name: 'eduCenter_teachers_edit',
    meta: {
      title: '教师修改',
      activePath: '/eduCenter/teachers/index',
      breadcrumb: '教务中心-师资管理-教师师资库-教师修改'
    },
    component: TeachersEdit
  }
]
